export default "https://cdnpdfront.aikan.pdnews.cn/rmrb/es/rmrb-web-details-main/1.0.24/resource/image/channel.svg"